/**
 * Floating LINE Friends button.
 *
 * 常時表示する LINE 導線。位置・サイズは component-floating-line.css 側で制御。
 * 商品ページの sticky-cart 表示時の持ち上げも CSS の :has() で対応。
 */
(function () {
    'use strict';

    var BUTTON_SELECTOR = '[data-floating-line-button]';
    var VISIBLE_ATTR = 'data-floating-line-visible';

    function init() {
        if (typeof document === 'undefined') {
            return;
        }
        var button = document.querySelector(BUTTON_SELECTOR);
        if (!button) {
            return;
        }
        button.removeAttribute('hidden');
        button.setAttribute(VISIBLE_ATTR, 'true');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();
